export default __webpack_public_path__ + "static/media/helpCenter_active.249addf6.svg";